import { isNumber } from 'radash'
import { usePaymentStore } from '@/stores/payment.js'

function calcFullPrice (priceInCurrency) {
  if (!priceInCurrency) {
    return null
  }

  const paymentStore = usePaymentStore()
  const taxPercent = Number(paymentStore.purchaseConfig?.defaultTaxation?.taxRateInPermyriads) / 100

  priceInCurrency = Number(priceInCurrency)

  if (paymentStore.purchaseConfig?.defaultTaxation && isNumber(taxPercent) && isNumber(priceInCurrency)) {
    return priceInCurrency / (100 - taxPercent) * 100
  }
  else {
    return priceInCurrency
  }
}

function calcExpectedPriceInCents (priceInCurrency) {
  if (!priceInCurrency || !isNumber(Number(priceInCurrency))) {
    return null
  }

  const paymentStore = usePaymentStore()

  const taxRate = Number(paymentStore.purchaseConfig?.defaultTaxation?.taxRateInPermyriads)
  const taxDisplayMode = paymentStore.purchaseConfig?.defaultTaxation?.taxDisplayMode

  const taxRateBase = 10000 // constant for tax rate base
  // const listPrice = parseInt(Number(priceInCurrency) * 100)
  const listPrice = parseInt(String(priceInCurrency).replace('.', ''))
  const listPriceUpscaled = listPrice * taxRateBase
  const taxRateComplement = taxRateBase - taxRate

  if (taxDisplayMode) {
    return (listPriceUpscaled - (listPriceUpscaled % taxRateComplement)) / taxRateComplement
  } else {
    return listPrice
  }
}

function calcPriceToShow (priceInCurrency, showAsterisk = true) {
  if (!priceInCurrency) {
    return null
  }

  const paymentStore = usePaymentStore()

  const taxDisplayMode = paymentStore.purchaseConfig?.defaultTaxation?.taxDisplayMode

  priceInCurrency = Number(priceInCurrency)
  const fullPrice = calcFullPrice(priceInCurrency)

  if (taxDisplayMode === 'included' && fullPrice) {
    return fullPrice.toFixed(2) + (showAsterisk ? '*' : '')
  }
  else if (taxDisplayMode === 'excluded') {
    return priceInCurrency.toFixed(2) + (showAsterisk ? '*' : '')
  }
  else {
    return priceInCurrency.toFixed(2)
  }
}

function calcSumTax (priceInCurrency) {
  if (!priceInCurrency) {
    return null
  }

  const paymentStore = usePaymentStore()

  const taxPercent = Number(paymentStore.purchaseConfig?.defaultTaxation?.taxRateInPermyriads) / 100
  const fullPrice = calcFullPrice(priceInCurrency)

  if (isNumber(taxPercent) && isNumber(fullPrice)) {
    return fullPrice * taxPercent / 100
  }
  else {
    return null
  }
}

function calcPriceWithTaxNote (t, priceInCurrency, is_tips = false) {
  if (!priceInCurrency) {
    return null
  }

  const paymentStore = usePaymentStore()

  const taxDisplayMode = paymentStore.purchaseConfig?.defaultTaxation?.taxDisplayMode
  const taxPercent = Number(paymentStore.purchaseConfig?.defaultTaxation?.taxRateInPermyriads) / 100
  const countryCode = paymentStore.purchaseConfig?.defaultTaxation?.countryCode

  let sumTax = calcSumTax(priceInCurrency)

  if (!isNumber(taxPercent) || !isNumber(sumTax)) {
    return ''
  }

  sumTax = sumTax ? sumTax.toFixed(2) : null

  if (taxDisplayMode && is_tips) {
    return t('tax_note_tips', { sumTax: sumTax, taxPercent: taxPercent })
  }
  else if (taxDisplayMode === 'included' && sumTax) {
    return t('tax_note_included', { sumTax: sumTax, taxPercent: taxPercent, countryCode: countryCode })
  }
  else if (taxDisplayMode === 'excluded') {
    return t('tax_note_excluded', { sumTax: sumTax, taxPercent: taxPercent, countryCode: countryCode })
  }

  return null
}

export {
  calcFullPrice,
  calcPriceToShow,
  calcSumTax,
  calcPriceWithTaxNote,
  calcExpectedPriceInCents
}